document.addEventListener("DOMContentLoaded", function () {
  const menuLinks = document.querySelectorAll(".as-menu-links");
  const isMobile = () => window.innerWidth <= 1024;

  // Handle Desktop: close on outside click or ESC
  document.addEventListener('keydown', function(event) {
    if (event.key === "Escape") {
      menuLinks.forEach(link => link.classList.remove('mega-menu-active'));
    }
  });

  document.addEventListener('click', function(event) {
    if (!event.target.closest('.as-header-nav')) {
      menuLinks.forEach(link => link.classList.remove('mega-menu-active'));
    }
  });

  // Handle Mobile: click to open accordion
  menuLinks.forEach(link => {
    const a = link.querySelector('a.as-links');
    const megaMenu = link.querySelector('.as-mega-menu');
    
    if (a && megaMenu) {
      a.addEventListener('click', function(e) {
        if (isMobile()) {
          return; // Let default link behavior navigate normally on mobile
        }
      });
    }
  });

  // Update Swiper on desktop hover so hidden menus calculate dimensions correctly
  menuLinks.forEach(link => {
    link.addEventListener('mouseenter', function() {
      if (isMobile()) return;
      const swiperContainer = link.querySelector('.as-mega-menu-swiper');
      if (swiperContainer && swiperContainer.swiper) {
        swiperContainer.swiper.update();
      }
    });
  });

  // Initialize Swiper for Mega Menu if present
  const swiperContainers = document.querySelectorAll('.as-mega-menu-swiper');
  if (swiperContainers.length > 0 && typeof Swiper !== 'undefined') {
    swiperContainers.forEach(container => {
      let slidesPerView = container.getAttribute('data-slides-per-view') || 3;
      
      new Swiper(container, {
        slidesPerView: slidesPerView,
        spaceBetween: 20,
        observer: true,
        observeParents: true,
        pagination: {
          el: container.querySelector('.swiper-pagination'),
          clickable: true,
        },
        breakpoints: {
          320: { slidesPerView: 1.2, spaceBetween: 15 },
          768: { slidesPerView: 3, spaceBetween: 20 },
          1024: { slidesPerView: slidesPerView, spaceBetween: 20 }
        }
      });
    });
  }
});
